import {Brand, BrandEnum} from "./brand";
import {getFromSessionStorage} from "./getFromSessionStorage";
import {getValidEnumValue} from "./isValidEnumValue";
import {ErrorType} from "config/errors";
import {notify} from "config/sentry";

const validateBrand = (maybeBrand: string | null | undefined) => getValidEnumValue(BrandEnum, maybeBrand);

export interface BrandState {
    brand: BrandEnum | undefined;
    error?: ErrorType;
}

export const getBrand = (): BrandEnum | undefined => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const brandFromUrl = validateBrand(Brand.getBrandFromUrl());
    const brandParam = validateBrand(urlParams.get("brand"));
    const brandFromSession = validateBrand(getFromSessionStorage<BrandState>("state", "brand"));

    const brand = brandParam || brandFromSession || brandFromUrl;

    if (!brand) {
        notify("No brand found", ErrorType.MISSING_BRAND, {
            brandParam,
            brandFromSession,
            brandFromUrl,
        });
    }

    return brand;
};
